import { useAuth } from "@/lib/auth";
import { LinkDoPaciente } from "./LinkDoPaciente";
import type { ProsthesisOrderRow } from "./types";

/** Pedido é de outra organização (na lista de todas, do acesso pessoal)? */
export function useDeOutraOrganizacao() {
  const { user } = useAuth();
  const ativa = user?.activeOrganization?.id;
  return (o: Pick<ProsthesisOrderRow, "organization">) => !!o.organization && o.organization.id !== ativa;
}

/** Nome do paciente na lista de pedidos e, na lista de todas as organizações, o selo de qual é.
 *  De outra clínica, o nome abre a ficha dela só leitura, sem trocar a organização ativa. */
export function PacienteDoPedido({ order }: { order: Pick<ProsthesisOrderRow, "patientId" | "patientName" | "organization"> }) {
  const deOutra = useDeOutraOrganizacao()(order);
  const org = order.organization;
  return (
    <>
      <LinkDoPaciente
        patientId={order.patientId}
        patientName={order.patientName}
        href={deOutra && org && order.patientId ? `/pacientes/em/${org.id}/${order.patientId}` : undefined}
      />
      {org && (
        <span className="ml-2 inline-block max-w-[12rem] truncate rounded-full bg-brand-50 px-2 py-0.5 align-middle text-[10px] font-semibold text-brand-700 no-underline dark:bg-primary/10 dark:text-primary">
          {org.isPersonal ? "Pessoal" : org.name}
        </span>
      )}
    </>
  );
}
